import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from "@mui/material";
import { useState } from "react";
import API from "../../../services/API";

const currentYear = parseInt(new Date().getFullYear());

const lastMonth = new Date(currentYear, new Date().getMonth() - 1, 1);
const defaultYear = lastMonth.getFullYear();
const defaultMonth = lastMonth.getMonth() + 1;

const months = ['', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const width = window.innerWidth > 600 ? 500 : 280;

const years = [0, 1, 2, 3].map(y => currentYear - y);

export default function CalotModal({open, onClose}){

    const [year, setYear] = useState(defaultYear)
    const [month, setMonth] = useState(defaultMonth)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    const handleSubmit = e => {

        e.preventDefault()

        setError(false)
        setLoading(true)

        API.download(`/crm/calots.csv?year=${year}&month=${month}`, `calots_${year}_${month}.csv`)
            .catch(_ => setError(true))
            .finally(() => setLoading(false))
    }

    return <Dialog open={open} onClose={onClose}>

        <DialogTitle>Commandes calots</DialogTitle>

        <form onSubmit={handleSubmit}>

            <DialogContent>

                <Stack spacing={2} sx={{minWidth: width, mt: 1}}>

                    <TextField
                        select 
                        label="Année"
                        required
                        size='small'
                        value={year}
                        onChange={e => setYear(parseInt(e.target.value))}
                    >
                        {years.map(y =>
                            <MenuItem key={y} value={y}>
                                {y}
                            </MenuItem>    
                        )}
                    </TextField>

                    <TextField
                        select 
                        label="Mois"
                        required
                        size='small'
                        value={month}
                        onChange={e => setMonth(parseInt(e.target.value))}
                    >
                        {[1,2,3,4,5,6,7,8,9,10,11,12].map(m =>
                            <MenuItem key={m} value={m}>
                                {months[m]}
                            </MenuItem>    
                        )}
                    </TextField>

                    {error && 
                        <Alert severity='error'>
                            Une erreur s'est produite.
                        </Alert>
                    }

                    <LoadingButton 
                        type='submit'
                        startIcon={<Download />}
                        loading={loading}
                    >
                        Télécharger
                    </LoadingButton>

                </Stack>

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
            </DialogActions>

        </form>

    </Dialog>

}
